module.exports = __webpack_public_path__ + "img/snow_wipe.adfb5aad.svg";